import * as RadixAvatar from '@radix-ui/react-avatar';
import { cn } from '@/shared/lib/cn';

/**
 * Fotoğrafın biçimi base64 imzasından okunur.
 *
 * Tip sabit "image/jpeg" yazılıyordu; profil fotoğrafı artık saydamlık varsa PNG olarak
 * saklanıyor (logo türü görsellerin köşeleri kararmasın diye). Chrome yanlış tipi
 * hoş görüyor ama Safari/Firefox'ta görsel hiç yüklenmeyebiliyor.
 */
function imageSrc(base64: string): string {
  const type = base64.startsWith('iVBOR')
    ? 'image/png'
    : base64.startsWith('R0lGOD')
      ? 'image/gif'
      : base64.startsWith('UklGR')
        ? 'image/webp'
        : 'image/jpeg';
  return `data:${type};base64,${base64}`;
}

export function Avatar({
  name,
  imageBase64,
  className,
}: {
  name: string;
  imageBase64?: string | null;
  className?: string;
}) {
  const initials = name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toLocaleUpperCase('tr'))
    .join('');
  return (
    <RadixAvatar.Root
      className={cn(
        'bg-brand-600 inline-flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-full text-xs font-semibold text-white',
        className,
      )}
    >
      {imageBase64 ? (
        <RadixAvatar.Image src={imageSrc(imageBase64)} alt={name} className="h-full w-full object-cover" />
      ) : null}
      <RadixAvatar.Fallback delayMs={0}>{initials || '?'}</RadixAvatar.Fallback>
    </RadixAvatar.Root>
  );
}
